import { getCookie } from "@/utils/common";
import { getUuidByToken } from '@/api/index.js';
export default {
    name: 'comi',
    methods: {
        jumpAIPage(){
            const token = getCookie('loginKey');
            if(!token){
                this.$confirm({
                    title: '提示',
                    content: '未登录，无法使用AI检索功能，请先登录',
                    okText: '去登录',
                    cancelText: '取消',
                    // centered: true,
                    onOk: ()=> {
                        this.$toLogin();
                    },
                    onCancel: ()=> {
                    }
                })
                return;
            }
            
            getUuidByToken({ token: decodeURIComponent(token) }).then((res) => {
                if (res.code == 200) {
                    const { uuid } = res.data
                    if (uuid) {
                        const version = localStorage.getItem("openSeeyonVersion")
                        const target = version.toLowerCase()
                        const url = `${process.env.VUE_APP_cloudUrl}/community/ai-open-seeyon?uuid=${uuid}&target=${target}`;
                        window.open(url);
                    }
                }else{
                    this.$warning({ title: (res && (res.msg || res.message)) || '获取uuid失败！' });
                }
            })
        }
    }
}